"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");exports.__esModule=true;exports.default=void 0;var _raphael=_interopRequireDefault(require("../vendors/redraphael/source/raphael.core"));_raphael.default.stopPartialEventPropagation=true;_raphael.default._stopabsolutePath=true;var _default={extension:_raphael.default,name:"redraphael",type:"plugin"};exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/core/src/_internal/redraphael/redraphael.js
// module id = ylcM
// module chunks = 5